import { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import AppProvider from './hooks';
import { Routes } from './routes';
import api from './services/api';
import GlobalStyle from './styles/global';

function App() {
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   let ajaxPending = 0;
  //   api.interceptors.request.use(
  //     request => {
  //       ajaxPending += 1;
  //       if (request.headers.load !== false) {
  //         setLoading(true);
  //       }
  //       return request;
  //     },
  //     error => {
  //       ajaxPending -= 1;
  //       if (ajaxPending === 0) {
  //         setLoading(false);
  //       }
  //       return Promise.reject(error);
  //     },
  //   );
  // }, []);

  // console.log(loading);

  return (
    <Router>
      <AppProvider>
        <Routes />
        <ToastContainer autoClose={3000} hideProgressBar />
        <GlobalStyle />
      </AppProvider>
    </Router>
  );
}

export default App;
